/**
* 基础菜单 商品管理
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>修改品牌基本信息 - {{serv2.groupName}} </el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" class="user-search"></el-form>

    <el-form label-width="120px" :model="serv" ref="serv">
      <el-form-item label="名称" prop="name">
        <el-input size="small" v-model="serv.groupName" auto-complete="off" placeholder="请输入品牌名称"></el-input>
      </el-form-item>
      <el-form-item label="品牌图片" prop="name">
        <el-upload class="avatar-uploader" action="http://39.107.109.196:14400/file/restaurant/ossUpload"
          :data="{ servId: serv.mchId, picType: 2 }" :show-file-list="false" name="imgFile"
          :on-success="handleAvatarSuccess">
          <img v-if="serv.groupLogo" :src=" serv.groupLogo"
            class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="结算方式" prop="name">
        <el-select v-model="serv.settlementType" placeholder="结算方式">
          <el-option v-for="item in invoiceFrom" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="开发票" prop="name">
        <el-select v-model="serv.invoiceFrom" placeholder="请选择谁开发票">
          <el-option v-for="item in invoiceFrom1" :key="item.id" :label="item.name" :value="item.id">
          </el-option>

        </el-select>
      </el-form-item>
      <!-- <el-form-item label="备注" prop="name">
        <el-input size="small" v-model="serv.remark" auto-complete="off" placeholder="请输入备注"></el-input>
      </el-form-item> -->
      <!--      <el-form-item label="品牌管理员码" prop="name">
        <img style="width: 200px;height: 200px;" :src=erwm1>
        <div id="" style="width: 200px;text-align: center;margin-top: -20px;">
          {{serv.groupName}}
        </div>
      </el-form-item> -->


    </el-form>
    <div slot="footer" class="dialog-footer" style="display: flex; justify-content: center;">
      <el-button size="small" @click="$router.back(-1)">取消</el-button>
      <el-button size="small" type="primary" class="title" @click="submitForm('editForm')">保存
      </el-button>
    </div>

  </div>
</template>

<script>
  import {
    getMerchantGroupDetail,
    updateMerchantGroup,
    create3
  } from '../../api/userMG'
  import Pagination from '../../components/Pagination'
  export default {
    data() {
      return {
        xg1: 0,
        editForm: {
          bank_info: '',
          branch_name: '',
          bank_id: '',
          token: localStorage.getItem('logintoken')
        },
        title: '添加',
        province1: [],
        invoiceFrom: [{
            id: 1,
            name: '直接结算'
          },
          {
            id: 2,
            name: '核销结算'
          }
        ],
        invoiceFrom1: [{
            id: 1,
            name: '商家开发票'
          },
          {
            id: 2,
            name: '平台开发票'
          }
        ],
        province_code: '',
        city1: [],
        city_code: '',
        bankCode: '',
        branchlist: [],
        bank_id: '',
        mchId: this.$route.query.id,
        serv: '',
        serv2: '',
        bankCardNo: '',
        erwm1: ''
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 数据发生改变
     */

    /**
     * 创建完毕
     */
    created() {
      // this.province()

      this.merchantDetail()
    },
    methods: {
      merchantDetail() {
        let pro = {
          "userId": JSON.parse(localStorage.getItem('userdata')).muId,
          "groupId": this.mchId
        }
        getMerchantGroupDetail(pro).then(res => {
          // if (res.data.bankInfo) {
          //   res.data.bankInfo1 = res.data.bankInfo.split('|')
          // } else {
          //   res.data.bankInfo1 = ['', '', '', '']
          // }
          this.serv = JSON.parse(JSON.stringify(res.data))
          this.serv2 = JSON.parse(JSON.stringify(res.data))
          // this.create3()
        })
      },
      create3() {
        this.erwm1 = ''
        let por = {
          "content": {
            "scene_str": "a|" + this.mchId + '|' + this.serv.groupName
          }
        }
        create3(por).then(res => {
          this.erwm1 = 'https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=' + encodeURI(res
            .data
            .ticket)
        })
      },
      submitForm() {
        let pro = {
          "userId": JSON.parse(localStorage.getItem('userdata')).muId,
          "groupId": this.mchId,
          "groupName": this.serv.groupName,
          settlementType: this.serv.settlementType,
          groupLogo: this.serv.groupLogo,
          invoiceFrom: this.serv.invoiceFrom,
        }
        updateMerchantGroup(pro).then((res) => {
          if (res.code == 0) {
            this.$message({
              message: '修改成功',
              type: 'success'
            });
            this.$router.push({
              name: '品牌管理'
            })
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
      },
      handleAvatarSuccess(res, file) {
        this.serv.groupLogo = res.data.fileDownloadUri;
      },

    }
  }
</script>

<style scoped>
  .user-search {
    margin-top: 20px;
  }

  .userRole {
    width: 100%;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/views/group/groupModify.vue